import { apiClientV1 } from './apiClient';

export default {
  getReportColumns: () => apiClientV1.get('/report/columns?userType=client'),
  /**
   * "dataTypes": [
       {
          "type": "summary",
          "columns": ["string"]
       }
     ],
     "email": "user@example.com",
     "startDate": "string",
     "endDate": "string",
     "propertyIds": ["string"]
   */
  generateReport: (data) => apiClientV1.post('/report/postgres', { ...data })
};
